<div
    #viewport
    class="tt-ai-chat-conversation"
    aria-live="polite"
    (scroll)="onScroll($event)"
    (wheel)="onUserScrollIntent()"
    (touchmove)="onUserScrollIntent()"
    (keydown)="onUserScrollIntent()"
>
    <div *ngIf="loading" class="tt-ai-chat-conversation__status">
        <tt-ai-chat-thinking></tt-ai-chat-thinking>
        <span ttTranslateWord="loading_chat"></span>
    </div>

    <p *ngIf="!loading && messages.length === 0" class="tt-ai-chat-conversation__status" ttTranslateWord="there_are_no_message_in_this_chat_yet"></p>

    <div *ngIf="loadingOlder" class="tt-ai-chat-conversation__history-skeleton" aria-hidden="true"><span></span><span></span></div>

    <div *ngIf="topSpacerHeight" class="tt-ai-chat-conversation__spacer" [style.height.px]="topSpacerHeight" aria-hidden="true"></div>

    <div #messageRow *ngFor="let message of renderedMessages; let messageIndex = index; trackBy: trackMessage" [attr.data-message-keyno]="message.ai_message_keyno">
        <tt-ai-chat-message [message]="message" [messageIndex]="messageIndex" (contentResized)="onMessageContentResized()"></tt-ai-chat-message>
    </div>

    <div *ngIf="bottomSpacerHeight" class="tt-ai-chat-conversation__spacer" [style.height.px]="bottomSpacerHeight" aria-hidden="true"></div>

    <div *ngIf="loadingNewer" class="tt-ai-chat-conversation__history-skeleton" aria-hidden="true"><span></span><span></span></div>

    <div *ngIf="sending" class="tt-ai-chat-conversation__message tt-ai-chat-conversation__message--response">
        <div class="tt-ai-chat-conversation__typing" aria-label="AI is responding">
            <tt-ai-chat-thinking></tt-ai-chat-thinking>
        </div>
    </div>
</div>
